import React from 'react';
import TextArea from '@wix/da-ds/pkg/formControls/dsPresets/TextArea';

export interface Props {
  id?: string;
  name?: string;
  label?: string;
  subLabel?: string;
  value?: string | null;
  defaultValue?: string | null;
  fullHeight?: boolean;
  placeholder?: string;
  error?: boolean;
  errorMessage?: string | null;
  rows?: number;
  autoSize?: boolean;
  maxLength?: number;
  skin?: { [k: string]: string };
  onChange?(value: string, event?): void; // event is not passed when autofilled by browser
  onClick?(event): void;
  onFocus?(event): void;
  onBlur?(event): void;
  wrapperClassName?: string;
  textareaClassName?: string;
  charactersRemainingClassName?: string;
  noBottomSpacing?: boolean;
  disabled?: boolean;
  isRequired?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      label,
      subLabel,
      maxLength,
      error,
      name,
      placeholder,
      errorMessage,
      id,
      value,
      defaultValue,
      textareaClassName,
      rows,
      autoSize,
      onFocus,
      onBlur,
      onChange,
      noBottomSpacing,
      disabled,
      isRequired,
    },
    ref
  ) => {
    const onKeyDown = e => {
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
        return;
      }

      const el = e.target;
      el.style.height = 'inherit';

      const computed = window.getComputedStyle(el);

      let desiredHeight = el.scrollHeight;
      for (const k of [
        'border-top-width',
        'padding-top',
        'padding-bottom',
        'border-bottom-width',
      ]) {
        desiredHeight += parseInt(computed.getPropertyValue(k), 10);
      }
      el.style.height = `${desiredHeight}px`;
    };

    return (
      <TextArea
        value={value || undefined}
        defaultValue={defaultValue || undefined}
        id={id ?? ''}
        label={label ?? ''}
        isLabelHidden={label === '' || label === undefined}
        subLabel={subLabel}
        ref={ref}
        name={name}
        rows={rows}
        validationResult={error || !!errorMessage ? 'error' : undefined}
        details={errorMessage || undefined}
        maxLength={maxLength}
        placeholder={placeholder}
        className={textareaClassName}
        onFocus={e => {
          onFocus && onFocus(e);
        }}
        onBlur={e => {
          onBlur && onBlur(e);
        }}
        onChange={e => {
          const v = e.target.value;
          onChange && onChange(v, e);
        }}
        onKeyDown={autoSize ? onKeyDown : undefined}
        noBottomSpacing={noBottomSpacing}
        disabled={disabled}
        isRequired={isRequired}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export default Textarea;
